const ROLE_TYPES = {
    UNKNOW_STUDENT: "15",
    OTHER: "9",
    LANDLORD: "5",
    INDIVIDUAL: "19",
    PROFESSIONAL: "20"
}

export default ROLE_TYPES;